import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {APIResponse} from '@core/interfaces/system/system-common';
import {HttpParams} from '@angular/common/http';
import {
    FeederAnalysisImpact,
    FeederList,
    N1AnalysisDetailsRequest,
    TransformerAnalysis,
    TransformerDetailedList,
    TransformerImpactSummary,
    TransformerList,
} from '@core/interfaces/engin/load-forecast/n1-analysis';

@Injectable()
export class N1AnalysisApi {
    private readonly PREFIX = 'infrastructure/peakload';
    private getUrlPrefix(workflowItemId: number) {
        return `${this.PREFIX}/${workflowItemId}/n1`;
    }

    constructor(private api: HttpService) {}

    public getFeedersLoadData(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<FeederList>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/infrastructure/feeder`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }

    public getTransformersLoadData(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerList>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/infrastructure/transformer`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }

    public getTransformerFeederTieResults(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerAnalysis>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/analysis/ties/transformer`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }

    public getFeederTieResults(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<FeederAnalysisImpact>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/analysis/ties/feeder`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }

    public getTransformerImpact(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerDetailedList>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/impact/load/transformer`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }

    public getTransformerImpactSummary(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerImpactSummary>> {
        return this.api.get(`${this.getUrlPrefix(workflowItemId)}/impact/summary/transformer`, {
            params: new HttpParams()
                .set('infrastructureType', params.infrastructureType)
                .set('infrastructureId', params.infrastructureId)
                .set('seasonId', params.seasonId)
                .set('scenario', params.scenario),
        });
    }
}
